import {
  mapActions,
  mapGetters,
} from 'vuex';

import {
  LicensePlate,
  Title,
  RegionDataForm,
} from '@/components';

import router from '@/router';

import validationFlow from '@/validation-flow';

export default {
  name: 'Step1LicensePlateMobileRegion',
  components: {
    [LicensePlate.name]: LicensePlate,
    [Title.name]: Title,
    [RegionDataForm.name]: RegionDataForm,
  },
  props: {},
  data: () => ({
    search: '',
    searchWatch: '',
    cityId: '',
    citiesFiltered: [],
  }),
  computed: {
    ...mapGetters('appointment', {
      licensePlate: 'getLicensePlate',
      loadingState: 'getLoadingState',
      vehicule: 'getVehiculeType',
      regionData: 'getRegionData',
    }),
    ...mapGetters('garage', {
      garages: 'getGarages',
      tireCodes: 'getTireCodes',
    }),
  },
  methods: {
    ...mapActions('appointment', {
      getCustomerDataRegion: 'FETCH_DATA_CUSTOMER_REGION',
    }),
    ...mapActions('garage', {
      getGarages: 'FETCH_DATA_GARAGES',
      getTireCodes: 'FETCH_DATA_TIRECODES',
    }),
    checkLicensePlate() {
      const regionDataForm = this.$refs.regionDataForm.$refs.form;

      regionDataForm.validate().then((isValid) => {
        if (isValid) {
            if (this.licensePlate !== '' && !this.loadingState) {
              this.getCustomerDataRegion({ licensePlate: this.licensePlate, postalCode: this.regionData.zipCode }).then(() => {
                validationFlow.validateStep1LicensePlateMobileRegion();
              }).catch(() => {
                // console.log(error);
                router.push({
                  name: 'error',
                });
              });
          }
        }
      });
    },

  },
  created() {
    if (this.garages.length === 0) {
      this.getGarages();
    }
    if (this.tireCodes.length === 0) {
      this.getTireCodes();
    }
  },
};
